import { useContext } from 'react'
import { AppContext } from '@state/context'
import { USER_ROLES } from '@helpers/constants'

// Teachers no longer browse sections or create their own books (customer
// request 2026-11-03). Set to true to give it back to teachers everywhere.
// Admins always keep it.
const TEACHERS_CAN_CREATE_BOOKS = false

const useOwnBooksAllowed = () => {
  const [state] = useContext(AppContext)
  const userRole = state?.app?.userRole

  return userRole === USER_ROLES.ADMIN || TEACHERS_CAN_CREATE_BOOKS
}

export { useOwnBooksAllowed }
